import axios from "../services/api/api";
// import { DELETE_COURSE_FULFILLED } from "./coursesActions";

export const FETCH_MODULES_BEGIN = "FETCH_MODULES_BEGIN";
export const FETCH_MODULES_FULFILLED = "FETCH_MODULES_FULFILLED";
export const FETCH_MODULES_REJECTED = "FETCH_MODULES_REJECTED";

export const FETCH_ALL_MODULES_BEGIN = "FETCH_ALL_MODULES_BEGIN";
export const FETCH_ALL_MODULES_FULFILLED = "FETCH_ALL_MODULES_FULFILLED";
export const FETCH_ALL_MODULES_REJECTED = "FETCH_ALL_MODULES_REJECTED";

export const FETCH_ALL_MODULES_WITH_COURSES_BEGIN =
  "FETCH_ALL_MODULES_WITH_COURSES_BEGIN";
export const FETCH_ALL_MODULES_WITH_COURSES_FULFILLED =
  "FETCH_ALL_MODULES_WITH_COURSES_FULFILLED";
export const FETCH_ALL_MODULES_WITH_COURSES_REJECTED =
  "FETCH_ALL_MODULES_WITH_COURSES_REJECTED";

export const FETCH_LWNAMES_BEGIN = "FETCH_LWNAMES_BEGIN";
export const FETCH_LWNAMES_FULFILLED = "FETCH_LWNAMES_FULFILLED";
export const FETCH_LWNAMES_REJECTED = "FETCH_LWNAMES_REJECTED";

export const DELETE_MODULES_FULFILLED = "DELETE_MODULES_FULFILLED";
export const DELETE_MODULES_REJECTED = "DELETE_MODULES_REJECTED";

export function fetchModules(courseId) {
  return function (dispatch) {
    dispatch({
      type: FETCH_MODULES_BEGIN,
      payload: { loading: true },
    });
    axios
      .get(`/Module/GetByCourseId?courseId=${courseId}`)
      .then((response) => {
        dispatch({
          type: FETCH_MODULES_FULFILLED,
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({ type: FETCH_MODULES_REJECTED, payload: err });
      });
  };
}

export function fetchAllModules() {
  return function (dispatch) {
    dispatch({
      type: FETCH_ALL_MODULES_BEGIN,
      payload: { loading: true },
    });
    axios
      .get(`/Module`)
      .then((response) => {
        dispatch({
          type: FETCH_ALL_MODULES_FULFILLED,
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({ type: FETCH_ALL_MODULES_REJECTED, payload: err });
      });
  };
}

export function fetchModulesWithCourses() {
  return function (dispatch) {
    dispatch({
      type: FETCH_ALL_MODULES_WITH_COURSES_BEGIN,
      payload: { loading: true },
    });
    axios
      .get(`/Module/GetWithCourses`)
      .then((response) => {
        dispatch({
          type: FETCH_ALL_MODULES_WITH_COURSES_FULFILLED,
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({
          type: FETCH_ALL_MODULES_WITH_COURSES_REJECTED,
          payload: err,
        });
      });
  };
}

export function fetchAvailableLwNames() {
  return function (dispatch) {
    dispatch({
      type: FETCH_LWNAMES_BEGIN,
      payload: { loading: true },
    });
    axios
      .get(`/Module/GetValidLwFileNames`)
      .then((response) => {
        dispatch({
          type: FETCH_LWNAMES_FULFILLED,
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({ type: FETCH_LWNAMES_REJECTED, payload: err });
      });
  };
}

export function deleteModule(moduleId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .delete("/Module/" + moduleId)
        .then((response) => {
          dispatch({
            type: DELETE_MODULES_FULFILLED,
          });
          resolve(true);
        })
        .catch((err) => {
          dispatch({ type: DELETE_MODULES_REJECTED, payload: err });
          reject(err);
        });
    });
  };
}
